import { render, staticRenderFns } from "./AddClientBatch.vue?vue&type=template&id=047d3658&scoped=true"
import script from "./AddClientBatch.vue?vue&type=script&lang=js"
export * from "./AddClientBatch.vue?vue&type=script&lang=js"
import style0 from "./AddClientBatch.vue?vue&type=style&index=0&id=047d3658&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047d3658",
  null
  
)

export default component.exports